
import { defineComponent, PropType, toRaw } from 'vue'

// components
import Cheap from '@/common/components/UI/Cheap/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// types
import { GatewayScopeT } from '@/core/types/gateway.types'

export default defineComponent({
    components: {
        cheap: Cheap,
        'the-button': TheButton,
    },
    props: {
        item: {
            type: Object as PropType<GatewayScopeT>,
            default: null,
        },
    },
    emits: ['update'],
    setup(props, { emit }) {
        const emitUpdate = () => {
            emit('update', toRaw(props.item))
        }

        return { emitUpdate }
    },
})
